import Bar from './BarChart'

const Chart = {
  Bar,
}

export default Chart
